// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-size: 100%;
}

*, :before, :after {
  box-sizing: border-box;
}

body {
  font: var(--lp-text-body-1-regular);
}

[data-theme] {
  background-color: var(--lp-color-bg-ui-primary);
  color: var(--lp-color-text-ui-primary-base);
}

h1, h2, h3 {
  color: var(--lp-color-text-ui-primary-base);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/base.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,SAAS;AACX","sourcesContent":["html {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizelegibility;\n  font-size: 100%;\n}\n\n*, :before, :after {\n  box-sizing: border-box;\n}\n\nbody {\n  font: var(--lp-text-body-1-regular);\n}\n\n[data-theme] {\n  background-color: var(--lp-color-bg-ui-primary);\n  color: var(--lp-color-text-ui-primary-base);\n}\n\nh1, h2, h3 {\n  color: var(--lp-color-text-ui-primary-base);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
